import {initPurchaseConfirmationResult} from '@web/actions/purchaseConfirmation'
import makeSlice from '@web/slices/banner/sliceMaker'

const bannerSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initPurchaseConfirmationResult.fulfilled, (state, {payload: {data}}) => {
            state.userNickName = data.userNickName
        })
    },
})

export default bannerSlice.reducer
